module.exports = __webpack_public_path__ + "static/media/Item_Weapon_StickyGrenade_C.69f876f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/item/Weapon/Throwable/Item_Weapon_StickyGrenade_C.png
// module id = 261
// module chunks = 0